import MainComponentWrapper from "../../../Components/Common/MainComponentWrapper";
import { getImageUrl } from "../../../utils/Helper";

const PLATFORM_CTA = {
  music: "Listen Now",
  classes: "Explore Class",
  merch: "Shop Now",
  "product-details": "Shop Now",
  tv: "Watch Now",
  social: "View Post",
};

const getAddonCtaLabel = (platform) =>
  PLATFORM_CTA[String(platform || "").toLowerCase()] || "Explore";

const truncate = (text, max) => {
  if (!text) return "";
  return text.length > max ? `${text.substring(0, max)}...` : text;
};

const AddonsList = (props) => {
  const {
    loading,
    error,
    addons = [],
    actions,
    redirection = false,
    selectedAddons,
    showHeading,
    heading = "Explore More on Danzflo",
    subheading = "Based on your interest in this event, check out other experiences from the Danzflo universe.",
    layout = "grid",
  } = props;

  if (!redirection) {
    if (addons.length > 0) {
      return (
        <div className="event-addons-grid">
          {addons.map((addon) => (
            <article className="event-addon-card" key={addon._id}>
              <div className="event-addon-card-media">
                <img
                  className="event-addon-card-image"
                  src={getImageUrl(addon.image || "")}
                  alt={addon.title || "Add-on"}
                />
                {actions && (
                  <div className="event-addon-card-actions">
                    {actions(addon)}
                  </div>
                )}
              </div>
              <div className="event-addon-card-body">
                <h4 className="event-addon-card-name">{addon.title}</h4>
                {addon.description && (
                  <p className="event-addon-card-description">
                    {truncate(addon.description, 160)}
                  </p>
                )}
                <p className="event-addon-card-price">
                  USD {Number(addon.price || 0).toFixed(2)}
                </p>
              </div>
            </article>
          ))}
        </div>
      );
    }

    if (loading) {
      return (
        <div className="event-addons-loading" role="status" aria-live="polite">
          <span className="event-addons-loading-text">Loading add-ons...</span>
        </div>
      );
    }

    return (
      <div className="event-addons-empty">
        <i className="bi bi-box-seam" aria-hidden="true" />
        <h3>No add-ons yet</h3>
        <p>
          Create optional add-ons that attendees can purchase with their
          tickets.
        </p>
      </div>
    );
  }

  const isExplore = layout === "explore";

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div
        className={`event-thanks-addons-panel${
          isExplore ? " event-thanks-addons-panel--explore" : ""
        }`}
      >
        {showHeading && (loading || addons.length > 0) ? (
          <div className="event-thanks-addons-intro">
            <h3 className="event-thanks-addons-title">{heading}</h3>
            {subheading ? (
              <p className="event-thanks-addons-sub">{subheading}</p>
            ) : null}
          </div>
        ) : null}

        {loading && addons.length === 0 ? (
          <div
            className="event-addons-loading"
            role="status"
            aria-live="polite"
          >
            <span className="event-addons-loading-text">Loading add-ons...</span>
          </div>
        ) : null}

        {addons.length > 0 ? (
          <div
            className={
              isExplore
                ? "event-thanks-explore-list"
                : "event-addons-grid event-thanks-addons-grid"
            }
          >
            {addons.map((addon) => {
              const isSelected = Boolean(
                selectedAddons?.find((item) => item.addonId === addon._id)
              );
              const description = truncate(addon?.description, 120);
              const cta = getAddonCtaLabel(addon.platform);
              const price = Number(addon.price || 0).toFixed(2);

              if (isExplore) {
                return (
                  <article
                    className={`event-thanks-explore-card${
                      isSelected ? " is-selected" : ""
                    }`}
                    key={addon._id}
                  >
                    <div className="event-thanks-explore-thumb">
                      <img
                        src={getImageUrl(addon.image || "")}
                        alt={addon.title || "Add-on"}
                      />
                    </div>
                    <div className="event-thanks-explore-content">
                      <div className="event-thanks-explore-meta">
                        <h4 className="event-thanks-explore-name">
                          {addon.title || "Add-on"}
                        </h4>
                        {description ? (
                          <p className="event-thanks-explore-desc">
                            {description}
                          </p>
                        ) : null}
                      </div>
                      <div className="event-thanks-explore-footer">
                        <span className="event-thanks-explore-price">
                          ${price}
                        </span>
                        {addon.redirectionLink ? (
                          <button
                            type="button"
                            className="event-thanks-explore-cta"
                            onClick={() =>
                              window.open(
                                addon.redirectionLink,
                                "_blank",
                                "noopener"
                              )
                            }
                          >
                            {cta}
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </article>
                );
              }

              return (
                <article
                  className={`event-addon-card${
                    isSelected ? " is-selected" : ""
                  }`}
                  key={addon._id}
                >
                  <div className="event-addon-card-media">
                    <img
                      className="event-addon-card-image"
                      src={getImageUrl(addon.image || "")}
                      alt={addon.title || "Add-on"}
                    />
                  </div>
                  <div className="event-addon-card-body">
                    <h4 className="event-addon-card-name">
                      {addon.title || "Add-on"}
                    </h4>
                    {description ? (
                      <p className="event-addon-card-description">
                        {description}
                      </p>
                    ) : null}
                    <p className="event-addon-card-price">USD {price}</p>
                    {addon.redirectionLink ? (
                      <button
                        type="button"
                        className="event-addon-card-cta"
                        onClick={() =>
                          window.open(
                            addon.redirectionLink,
                            "_blank",
                            "noopener"
                          )
                        }
                      >
                        {cta}
                      </button>
                    ) : null}
                  </div>
                </article>
              );
            })}
          </div>
        ) : null}
      </div>
    </MainComponentWrapper>
  );
};

export default AddonsList;
